import React from 'react';
import dayjs from 'dayjs';

/** Readable campaign timestamps — date on first line, time on second. */
export function formatCampaignDateTime(value) {
  if (!value) return '—';
  const d = dayjs(value);
  if (!d.isValid()) return '—';
  return (
    <>
      <span className="dt-date">{d.format('MMM D, YYYY')}</span>
      <span className="dt-time">{d.format('h:mm A')}</span>
    </>
  );
}

const COUPON_PLACEHOLDER = '{{coupon_code}}';

/** Message as customers get it; must match render_campaign_message on the backend. */
export function renderCampaignBody(body, couponCode) {
  const text = body || '';
  const code = (couponCode || '').trim();
  if (!code) return text;
  if (text.includes(COUPON_PLACEHOLDER)) return text.split(COUPON_PLACEHOLDER).join(code);
  return `${text.trimEnd()}\n\nUse code: ${code}`;
}

export function formatCampaignDate(value) {
  if (!value) return '—';
  const d = dayjs(value);
  if (!d.isValid()) return '—';
  return d.format('MMM D, YYYY');
}
